{
  "familyId": "GET-BREUK-GEL-PLUS",
  "questions": [
    {
      "id": "GET-BREUK-GEL-PLUS-001",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{4}$ + $\\frac{2}{4}$ =",
      "context": null,
      "options": ["$\\frac{3}{4}$", "$\\frac{3}{8}$", "$\\frac{2}{4}$", "$\\frac{1}{2}$"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_quarters",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 4, "label": "1/4"},
              {"numerator": 2, "denominator": 4, "label": "2/4"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "1/4 + 2/4 = 3/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{3}{4}$. Bij gelijknamige breuken tel je de tellers op: 1 + 2 = 3. De noemer blijft hetzelfde: 4. Dus $\\frac{1}{4}$ + $\\frac{2}{4}$ = $\\frac{3}{4}$.",
        "distractorExplanations": {
          "0": "Goed! Tel de tellers op: 1 + 2 = 3, noemer blijft 4. Dus $\\frac{1}{4}$ + $\\frac{2}{4}$ = $\\frac{3}{4}$.",
          "1": "$\\frac{3}{8}$ is fout. Je hebt misschien de noemers ook opgeteld (4 + 4 = 8), maar dat mag niet. Bij gelijknamige breuken blijft de noemer hetzelfde: $\\frac{1}{4}$ + $\\frac{2}{4}$ = $\\frac{3}{4}$.",
          "2": "$\\frac{2}{4}$ is fout. Je hebt maar één van de twee breuken genomen. Tel beide tellers op: 1 + 2 = 3, dus $\\frac{1}{4}$ + $\\frac{2}{4}$ = $\\frac{3}{4}$.",
          "3": "$\\frac{1}{2}$ is wel gelijk aan $\\frac{2}{4}$ (vereenvoudigd), maar niet het antwoord op deze som. $\\frac{1}{4}$ + $\\frac{2}{4}$ = $\\frac{3}{4}$, niet $\\frac{1}{2}$ (= $\\frac{2}{4}$)."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-002",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{2}{5}$ + $\\frac{1}{5}$ =",
      "context": null,
      "options": ["$\\frac{3}{5}$", "$\\frac{3}{10}$", "$\\frac{2}{5}$", "$\\frac{1}{5}$"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_fifths",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 2, "denominator": 5, "label": "2/5"},
              {"numerator": 1, "denominator": 5, "label": "1/5"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 5,
            "label": "2/5 + 1/5 = 3/5",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{3}{5}$. Tel de tellers op: 2 + 1 = 3. De noemer blijft 5. Dus $\\frac{2}{5}$ + $\\frac{1}{5}$ = $\\frac{3}{5}$.",
        "distractorExplanations": {
          "0": "Goed! Tel de tellers op: 2 + 1 = 3, noemer blijft 5. Dus $\\frac{2}{5}$ + $\\frac{1}{5}$ = $\\frac{3}{5}$.",
          "1": "$\\frac{3}{10}$ is fout. Je hebt de noemers ook opgeteld (5 + 5 = 10), maar dat mag niet. Bij gelijknamige breuken blijft de noemer hetzelfde: $\\frac{2}{5}$ + $\\frac{1}{5}$ = $\\frac{3}{5}$.",
          "2": "$\\frac{2}{5}$ is fout. Je hebt de tweede breuk niet opgeteld. Tel beide tellers op: 2 + 1 = 3, dus $\\frac{2}{5}$ + $\\frac{1}{5}$ = $\\frac{3}{5}$.",
          "3": "$\\frac{1}{5}$ is fout. Je hebt de eerste breuk niet opgeteld. Tel beide tellers op: 2 + 1 = 3, dus $\\frac{2}{5}$ + $\\frac{1}{5}$ = $\\frac{3}{5}$."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-003",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{3}{8}$ + $\\frac{2}{8}$ =",
      "context": null,
      "options": ["$\\frac{5}{8}$", "$\\frac{5}{16}$", "$\\frac{6}{8}$", "$\\frac{1}{8}$"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_eighths",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 3, "denominator": 8, "label": "3/8"},
              {"numerator": 2, "denominator": 8, "label": "2/8"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 8,
            "label": "3/8 + 2/8 = 5/8",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{5}{8}$. Tel de tellers op: 3 + 2 = 5. De noemer blijft 8. Dus $\\frac{3}{8}$ + $\\frac{2}{8}$ = $\\frac{5}{8}$.",
        "distractorExplanations": {
          "0": "Goed! Tel de tellers op: 3 + 2 = 5, noemer blijft 8. Dus $\\frac{3}{8}$ + $\\frac{2}{8}$ = $\\frac{5}{8}$.",
          "1": "$\\frac{5}{16}$ is fout. Je hebt de noemers ook opgeteld (8 + 8 = 16), maar dat mag niet. Bij gelijknamige breuken blijft de noemer hetzelfde: $\\frac{3}{8}$ + $\\frac{2}{8}$ = $\\frac{5}{8}$.",
          "2": "$\\frac{6}{8}$ is fout. Je hebt misschien 3 × 2 = 6 berekend in plaats van 3 + 2 = 5. Tel de tellers op, vermenigvuldig ze niet.",
          "3": "$\\frac{1}{8}$ is fout. Je hebt misschien 3 − 2 = 1 berekend in plaats van 3 + 2 = 5. Je moet optellen, niet aftrekken."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-004",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{6}$ + $\\frac{4}{6}$ =",
      "context": null,
      "options": ["$\\frac{5}{6}$", "$\\frac{5}{12}$", "$\\frac{4}{6}$", "$\\frac{1}{6}$"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_sixths",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 6, "label": "1/6"},
              {"numerator": 4, "denominator": 6, "label": "4/6"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 6,
            "label": "1/6 + 4/6 = 5/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{5}{6}$. Tel de tellers op: 1 + 4 = 5. De noemer blijft 6. Dus $\\frac{1}{6}$ + $\\frac{4}{6}$ = $\\frac{5}{6}$.",
        "distractorExplanations": {
          "0": "Goed! Tel de tellers op: 1 + 4 = 5, noemer blijft 6. Dus $\\frac{1}{6}$ + $\\frac{4}{6}$ = $\\frac{5}{6}$.",
          "1": "$\\frac{5}{12}$ is fout. Je hebt de noemers ook opgeteld (6 + 6 = 12), maar dat mag niet. Bij gelijknamige breuken blijft de noemer hetzelfde.",
          "2": "$\\frac{4}{6}$ is fout. Je hebt alleen de tweede breuk genomen en de eerste vergeten. Tel beide tellers op: 1 + 4 = 5.",
          "3": "$\\frac{1}{6}$ is fout. Je hebt alleen de eerste breuk genomen en de tweede vergeten. Tel beide tellers op: 1 + 4 = 5."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-005",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Lisa eet $\\frac{2}{8}$ van een pizza. Haar broer eet $\\frac{3}{8}$. Hoeveel pizza hebben ze samen gegeten?",
      "context": null,
      "options": ["$\\frac{5}{8}$", "$\\frac{5}{16}$", "$\\frac{6}{8}$", "$\\frac{1}{8}$"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_context",
      "variantIndex": 5,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 2, "denominator": 8, "label": "Lisa: 2/8"},
              {"numerator": 3, "denominator": 8, "label": "Broer: 3/8"}
            ],
            "operator": "+",
            "visualType": "circle"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 8,
            "label": "2/8 + 3/8 = 5/8 van de pizza",
            "visualType": "circle"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{5}{8}$. Lisa eet $\\frac{2}{8}$ en haar broer $\\frac{3}{8}$. Samen: $\\frac{2}{8}$ + $\\frac{3}{8}$ = $\\frac{5}{8}$ van de pizza. Tel de tellers op: 2 + 3 = 5. De noemer (8 punten) blijft hetzelfde.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{2}{8}$ + $\\frac{3}{8}$ = $\\frac{5}{8}$ van de pizza.",
          "1": "$\\frac{5}{16}$ is fout. Je hebt de noemers ook opgeteld (8 + 8 = 16). Maar de pizza is in 8 stukken verdeeld, niet 16. De noemer blijft 8.",
          "2": "$\\frac{6}{8}$ is fout. Je hebt misschien 2 × 3 = 6 berekend. Maar je moet optellen: 2 + 3 = 5, dus $\\frac{5}{8}$.",
          "3": "$\\frac{1}{8}$ is fout. Je hebt misschien 3 − 2 = 1 berekend. Maar de vraag is hoeveel ze samen eten — dat is optellen: 2 + 3 = 5."
        }
      }
    }
  ]
}